"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alphabeticalSortingComparator = void 0;
function alphabeticalSortingComparator(a, b) {
    const A = a.toLowerCase();
    const B = b.toLowerCase();
    if (A < B) {
        return -1;
    }
    if (A > B) {
        return 1;
    }
    return 0;
}
exports.alphabeticalSortingComparator = alphabeticalSortingComparator;
//# sourceMappingURL=comparator.js.map